import clsx from 'clsx';

export function cn(...args) {
  return clsx(...args);
}
